<template>
  <div class="stbox">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>医院信息</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card" v-if="show">
      <div slot="header" class="clearfix">
        <span>医院信息</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="show = false">编辑</el-button>
      </div>
      <div class="text item">
        {{ "医院编号：" + hospitalData[0].HospitalNumber }}
      </div>
      <div class="text item">
        {{ "医院名称：" + hospitalData[0].HospitalName }}
      </div>
      <div class="text item">
        {{ "医院等级：" + hospitalData[0].HospitalLevel }}
      </div>
      <div class="text item">
        {{ "医院类型：" + hospitalData[0].HospitalType }}
      </div>
      <div class="text item">
        {{ "医院种类：" + hospitalData[0].hospitalNature }}
      </div>
      <div class="text item">
        {{ "医院性质：" + hospitalData[0].hospitalProperty }}
      </div>
      <div class="text item">
        {{ "床位数：" + hospitalData[0].hospitalNumberOfBed }}
      </div>
      <div class="text item">
        {{ "数据来源：" + hospitalData[0].source }}
      </div>
      <div class="text item">
        {{ "是否使用院感信息系统：" + hospitalData[0].isUseSystem }}
      </div>
      <div class="text item">
        {{ "所属地区：" + hospitalData[0].Area }}
      </div>
      <div class="text item">
        {{ "医院地址：" + hospitalData[0].hospitalAddress }}
      </div>
      <div class="text item">
        {{ "办公室负责人：" + hospitalData[0].OfficeFZR }}
      </div>
      <div class="text item">
        {{ "办公室负责人电话：" + hospitalData[0].OfficeFZRphone }}
      </div>
      <div class="text item">
        {{ "办公室联系人：" + hospitalData[0].OfficeLXR }}
      </div>
      <div class="text item">
        {{ "办公室联系人电话：" + hospitalData[0].OfficeLXRphone }}
      </div>
    </el-card>
    <el-card class="box-card" v-if="!show">
      <div slot="header" class="clearfix">
        <span>编辑医院信息</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="confirm">提交</el-button>
      </div>
      <el-form label-position="right" :model="hospital" ref="hospital" label-width="130px"
        class="demo-ruleForm login-container">
        <el-form-item prop="hospitalNumber" label="医院编号">
          <el-input disabled type="text" v-model="hospital.hospitalNumber" auto-complete="off"
            placeholder="请输入医院编号"></el-input>
          <!-- :disabled="isEdit"  -->
        </el-form-item>
        <el-form-item prop="hospitalName" label="医院名称">
          <el-input disabled type="text" v-model="hospital.hospitalName" auto-complete="off"
            placeholder="请输入医院名称"></el-input>
        </el-form-item>
        <el-form-item prop="hospitalLevel" label="医院等级">
          <el-select style="width: 100%" v-model="hospital.hospitalLevel" filterable placeholder="请选择医院等级">
            <el-option v-for="item in allHospitalLevel" :key="item.hospitalLevel" :label="item.hospitalLevel"
              :value="item.hospitalLevel">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="hospitalType" label="医院类型">
          <el-select style="width: 100%" v-model="hospital.hospitalType" filterable placeholder="请选择医院类型">
            <el-option v-for="item in allHospitalType" :key="item.hospitalType" :label="item.hospitalType"
              :value="item.hospitalType">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="hospitalNature" label="医院种类">
          <el-select style="width: 100%" v-model="hospital.hospitalNature" filterable placeholder="请选择医院种类">
            <el-option v-for="item in allHospitalNature" :key="item.hospitalNature" :label="item.hospitalNature"
              :value="item.hospitalNature">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="hospitalProperty" label="医院性质">
          <el-select style="width: 100%" v-model="hospital.hospitalProperty" filterable placeholder="请选择医院性质">
            <el-option v-for="item in allHospitalProperty" :key="item.hospitalProperty" :label="item.hospitalProperty"
              :value="item.hospitalProperty">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="hospitalNumberOfBed" label="床位数">
          <el-input-number v-model="hospital.hospitalNumberOfBed"></el-input-number>
        </el-form-item>
        <el-form-item prop="source" label="数据来源">
          <el-select style="width: 100%" v-model="hospital.source" filterable placeholder="请选择数据来源">
            <el-option v-for="item in allsource" :key="item.source" :label="item.source" :value="item.source">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="isUseSystem" label="使用院感信息系统">
          <el-select style="width: 100%" v-model="hospital.isUseSystem" filterable placeholder="请选择是否使用院感信息系统">
            <el-option v-for="item in allSystem" :key="item.source" :label="item.source" :value="item.source">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="area" label="所属地区">
          <el-cascader filterable clearable v-model="hospital.area" :options="area" style="width: 100%"
            @change="handleChange"></el-cascader>
        </el-form-item>
        <el-form-item prop="hospitalAddress" label="医院地址">
          <el-input type="text" v-model="hospital.hospitalAddress" auto-complete="off" placeholder="请输入医院地址"></el-input>
        </el-form-item>
        <el-form-item prop="officeFZR" label="办公室负责人">
          <el-input type="text" v-model="hospital.officeFZR" auto-complete="off" placeholder="请输入办公室负责人"></el-input>
        </el-form-item>
        <el-form-item prop="officeFZRphone" label="办公室负责人电话">
          <el-input type="text" v-model="hospital.officeFZRphone" auto-complete="off"
            placeholder="请输入办公室负责人电话"></el-input>
        </el-form-item>
        <el-form-item prop="officeLXR" label="办公室联系人">
          <el-input type="text" v-model="hospital.officeLXR" auto-complete="off" placeholder="请输入办公室联系人"></el-input>
        </el-form-item>
        <el-form-item prop="officeLXRphone" label="办公室联系人电话">
          <el-input type="text" v-model="hospital.officeLXRphone" auto-complete="off"
            placeholder="请输入办公室联系人电话"></el-input>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script type="text/ecmascript-6">
import {
  getHospital2,
  updateHospitalInfo,
  getAllArea,
  getHospitalArea,
} from "../../api/hospital";
import { regionData, codeToText } from "element-china-area-data";
export default {
  name: "welcome",
  data() {
    return {
      hospitalNumber: "",
      hospitalName: "",
      loginUser: {},
      hospitalData: [],
      show: true,
      hospital: {
        id: '',
        hospitalNumber: "",
        hospitalName: "",
        hospitalLevel: "",
        hospitalType: "",
        hospitalNature: "",
        hospitalProperty: "",
        hospitalNumberOfBed: "",
        area: "",
        hospitalAddress: "",
        officeFZR: "",
        officeFZRphone: "",
        officeLXR: "",
        officeLXRphone: "",
        source: "",
        isUseSystem: ''
      },
      isEdit: true,
      area: [],
      allHospitalLevel: [
        { hospitalLevel: "一级甲等" },
        { hospitalLevel: "一级丙等" },
        { hospitalLevel: "一级乙等" },
        { hospitalLevel: "二级甲等" },
        { hospitalLevel: "二级乙等" },
        { hospitalLevel: "二级丙等" },
        { hospitalLevel: "三级特等" },
        { hospitalLevel: "三级甲等" },
        { hospitalLevel: "三级丙等" },
        { hospitalLevel: "三级乙等" },
      ],
      allsource: [{ source: "全院" }, { source: "ICU" }],
      allSystem: [{ source: "是" }, { source: "否" }],
      allHospitalType: [
        { hospitalType: "综合医院" },
        { hospitalType: "中医医院" },
        { hospitalType: "中西医结合医院" },
        { hospitalType: "民族医院" },
        { hospitalType: "专科医院" },
        { hospitalType: "康复医院" },
        { hospitalType: "妇幼保健院" },
      ],
      allHospitalNature: [
        { hospitalNature: "大学院校附属医院" },
        { hospitalNature: "非大学院校附属医院" },
      ],
      allHospitalProperty: [
        { hospitalProperty: "公立医院" },
        { hospitalProperty: "私营医院" },
      ],
    };
  },
  mounted() {
    this.loginUser = JSON.parse(localStorage.getItem("userdata"))[0];
    this.hospitalName = this.loginUser.HospitalName;
    this.hospitalNumber = this.loginUser.HospitalNumber;
    this.getData();
    this.getAllArea();
    if (sessionStorage.getItem('status') == 'NO') {
      this.isEdit = false
      this.show = false
    } if (sessionStorage.getItem('status') == 'NO1') {
      this.show = false
    }
  },
  methods: {
    confirm() {
      this.hospital.area = this.hospital.area.toString()
      updateHospitalInfo(this.hospital).then((res) => {
        if (res.data > 0) {
          this.$message.success("医院信息修改成功");
          if (!this.isEdit) {
            setTimeout(() => {
              this.$store.commit("logout", "false");
              this.$router.push({ path: "/login" });
              this.$message({
                type: "success",
                message: "已退出登录!",
              });
            }, 1000)
          }
          this.show = true;
          this.getData();
        } else this.$message.error("医院信息修改失败");
      });
    },
    getData() {
      getHospital2({ hospitalName: this.hospitalName }).then((res) => {
        this.hospitalData = res.data;
        this.hospital.id = res.data[0].ID;
        this.hospital.hospitalNumber = res.data[0].HospitalNumber;
        this.hospital.hospitalName = res.data[0].HospitalName;
        this.hospital.hospitalLevel = res.data[0].HospitalLevel;
        this.hospital.hospitalType = res.data[0].HospitalType;
        this.hospital.hospitalNature = res.data[0].hospitalNature;
        this.hospital.hospitalProperty = res.data[0].hospitalProperty;
        this.hospital.hospitalNumberOfBed = res.data[0].hospitalNumberOfBed;
        this.hospital.hospitalAddress = res.data[0].hospitalAddress;
        this.hospital.source = res.data[0].source;
        this.hospital.isUseSystem = res.data[0].isUseSystem;
        this.hospital.area = res.data[0].Area.split(',').map(Number);
        this.hospital.officeFZR = res.data[0].OfficeFZR;
        this.hospital.officeFZRphone = res.data[0].OfficeFZRphone;
        this.hospital.officeLXR = res.data[0].OfficeLXR;
        this.hospital.officeLXRphone = res.data[0].OfficeLXRphone;
        getHospitalArea({ area: res.data[0].Area }).then((res2) => {
          this.hospitalData[0].Area = res2.data;
        });
      });
    },
    handleChange(event) {
      this.hospital.area = event.toString();
    },
    getAllArea() {
      this.area = [];
      getAllArea().then((res) => {
        this.area.push({
          value: res.data1[0].id,
          label: res.data1[0].name,
          children: [],
        });
        for (let i = 0; i < res.data2.length; i++) {
          this.area[0].children.push({
            value: res.data2[i].id,
            label: res.data2[i].name,
            children: [],
          });
        }
        for (let i = 0; i < res.data3.length; i++) {
          if (res.data3[i].cityid == 235) {
            this.area[0].children[0].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 236) {
            this.area[0].children[1].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 237) {
            this.area[0].children[2].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 238) {
            this.area[0].children[3].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 239) {
            this.area[0].children[4].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 240) {
            this.area[0].children[5].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 241) {
            this.area[0].children[6].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 242) {
            this.area[0].children[7].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 243) {
            this.area[0].children[8].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 244) {
            this.area[0].children[9].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 245) {
            this.area[0].children[10].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 246) {
            this.area[0].children[11].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 247) {
            this.area[0].children[12].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 248) {
            this.area[0].children[13].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 249) {
            this.area[0].children[14].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 250) {
            this.area[0].children[15].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 251) {
            this.area[0].children[16].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 252) {
            this.area[0].children[17].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 253) {
            this.area[0].children[18].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 254) {
            this.area[0].children[19].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 255) {
            this.area[0].children[20].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
        }
      });
    },
  },
};
</script>
<style>
.stbox {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 5px;
  margin-top: 25px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.box-card {
  margin-top: 35px;
  width: 480px;
}
</style>



// WEBPACK FOOTER //
// src/views/charts/edit.vue